import type { RouteObject } from 'react-router';

/**
 * The two routes that live OUTSIDE the shell.
 *
 * `/login` is public. `/pin` sits inside `RequireAuth` but outside
 * `RequirePinChanged` — it is the one authenticated screen a caller with
 * `mustChangePin` is allowed to reach (§6) — so the router places it itself
 * rather than taking it from this array; see `app/router.tsx`.
 */
export const publicRoutes: RouteObject[] = [
  {
    path: '/login',
    lazy: async () => ({ Component: (await import('./LoginPage')).LoginPage }),
  },
];

export const pinRoute: RouteObject = {
  path: '/pin',
  lazy: async () => ({ Component: (await import('./PinChangePage')).PinChangePage }),
};

export const routes: RouteObject[] = [...publicRoutes, pinRoute];
